import { basePath, apiVersion } from "./config";

export function getSearchApi(data){
    const url = `${basePath}/${apiVersion}/get-search/${data}`;
  
    return fetch(url)
      .then(response => {
          return response.json();
      })
      .then(result => {
          return result;
      })
      .catch(err => {
          return err;
    })
  }

  export function getSearchCategoriesApi(){
    const url = `${basePath}/${apiVersion}/get-search-cat`;
  
    return fetch(url)
      .then(response => {
          return response.json();
      })
      .then(result => {
          return result;
      })
      .catch(err => {
          return err;
    })
  }

  export function getSearchBySubApi(id){
    const url = `${basePath}/${apiVersion}/get-searchbysub/${id}`;
  
    return fetch(url)
      .then(response => {
          return response.json();
      })
      .then(result => {
          return result;
      })
      .catch(err => {
          return err;
    })
  }

  export function getSearchWithCatApi(text, id){
    const url = `${basePath}/${apiVersion}/get-searchwithcat/${text}/${id}`;
  
    return fetch(url)
      .then(response => {
          return response.json();
      })
      .then(result => {
          return result;
      })
      .catch(err => {
          return err;
    })
  }

  export function getSearchByCatApi(id){
    const url = `${basePath}/${apiVersion}/get-searchbycat/${id}`;
  
    return fetch(url)
      .then(response => {
          return response.json();
      })
      .then(result => {
          return result;
      })
      .catch(err => {
          return err;
    })
  }